import { Grid, Stack, Typography } from "@mui/material";
import { orderBusiness } from "api/bussiness/order/order-bussiness";
import { PurchaseOrdersPermission } from "commons/enum/permission";
import { useCheckOwner } from "commons/hooks/use-check-owner";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { CustomerDealingAndActiveInfo } from "pages/common/customer-dealing-and-active-info";
import { useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PropertyInfo } from "share-components/atomics/property-info";
import {
  EditButton,
  GoBackIconButton,
  RemoveButton,
} from "share-components/mui-wrap/button/action-button";
import { PageContentScrollableContainer } from "share-components/templates/page/page-content-container";
import { PageDetailContainer } from "share-components/templates/page/page-detail-container";
import { PageHeaderContainer } from "share-components/templates/page/page-header-container";
import { EditOrder } from "../edit-order/edit-order";
import { EditUnitPrice } from "../edit-unit-price/edit-unit-price";
import { OrderStatusManagement } from "../order-status-management/order-status-management";
import { OrderItemTable } from "./order-item-table";

export const OrderDetail = observer(() => {
  const { orderId } = useParams();
  const {
    orderManagement: {
      getOrderDetail,
      openEdit,
      openManageStatus,
      openEditPrice,
    },
  } = useStores();

  useEffect(() => {
    if (orderId) {
      getOrderDetail(orderId);
    }
  }, [getOrderDetail, orderId]);
  return (
    <PageDetailContainer>
      <PageHeaderContainer direction={"row"} justifyContent={"space-between"}>
        <Header></Header>
      </PageHeaderContainer>
      <PageContentScrollableContainer>
        <Content></Content>
      </PageContentScrollableContainer>

      <>
        {openEdit && <EditOrder></EditOrder>}
        {openManageStatus && <OrderStatusManagement></OrderStatusManagement>}
        {openEditPrice && <EditUnitPrice></EditUnitPrice>}
      </>
    </PageDetailContainer>
  );
});
type HeaderProps = {};
const Header = observer((props: HeaderProps) => {
  const {
    orderManagement: { orderDetail, setProp: setOrderManagementProp },
    deleteConfirmationStore: { setProp, setDeletionCallback },
  } = useStores();
  const { isOwner } = useCheckOwner(orderDetail?.creatorId);
  const navigate = useNavigate();
  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);
  const onDelete = useCallback(
    async (id: string) => {
      if (id) {
        await orderBusiness.delete(id);
        goBack();
      }
    },
    [goBack]
  );
  const removeHandler = useCallback(() => {
    setProp("open", true);
    setDeletionCallback(() => {
      if (!orderDetail?.id) return;
      onDelete(orderDetail?.id);
    });
  }, [orderDetail, onDelete, setDeletionCallback, setProp]);

  const editHandler = useCallback(() => {
    setOrderManagementProp("openEdit", true);
  }, [setOrderManagementProp]);

  return (
    <>
      <Stack
        direction={"row"}
        justifyItems={"center"}
        spacing={1}
        alignItems={"center"}
      >
        <GoBackIconButton onClick={goBack}></GoBackIconButton>
        <Typography variant="subtitle2">{`Thông tin chi tiết `}</Typography>
      </Stack>
      {isOwner ? (
        <Stack direction={"row"} justifyItems={"center"} spacing={1}>
          <RemoveButton
            onClick={removeHandler}
            accessPermission={[PurchaseOrdersPermission.Delete]}
          ></RemoveButton>
          <EditButton
            onClick={editHandler}
            accessPermission={[PurchaseOrdersPermission.Update]}
          ></EditButton>
        </Stack>
      ) : (
        <></>
      )}
    </>
  );
});

const Content = observer(() => {
  const {
    orderManagement: { orderDetail },
  } = useStores();
  return (
    <Stack>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <PropertyInfo
            title="Ngày PO:"
            value={dateTimeDisplay(orderDetail?.poDate || "")}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Số PO:"
            value={orderDetail?.poNumber || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Tên giao dịch:"
            value={
              orderDetail?.customer ? (
                <CustomerDealingAndActiveInfo
                  customer={orderDetail?.customer}
                />
              ) : (
                <></>
              )
            }
          ></PropertyInfo>
        </Grid>
      </Grid>
      <Stack flex={1} paddingTop={"15px"} spacing={1}>
        <Typography variant="subtitle2" marginTop={"20px"}>
          Chi tiết mặt hàng
        </Typography>
        <OrderItemTable></OrderItemTable>
      </Stack>
    </Stack>
  );
});
